import { ADDED_DATE_LABEL } from "../../../utils/constants";
import { USER_ID_COLUMN_LABEL } from "../../../utils/registrationValidationStrings";

// Column model for the Users List table: order, labels, which columns sort.
// Widths live in users-list-bwai.css, one rule per `key` for heading and cell.
export const USERS_COLUMNS = [
  { key: "name", label: "Name", sortable: true },
  { key: "email", label: "Email", sortable: true },
  { key: "employeeId", label: USER_ID_COLUMN_LABEL, sortable: false },
  { key: "mobileNumber", label: "Mobile Number", sortable: true },
  { key: "addedDate", label: ADDED_DATE_LABEL, sortable: true },
  { key: "role", label: "Role", sortable: true },
  { key: "actions", label: "", sortable: false },
];
